module.exports = __webpack_public_path__ + "img/9788962631647.649bfc74.jpg";